/**
 * Table column definitions for client export tables
 */

export const LAB_TABLE_COLUMNS = ["Date", "Lab Name"];
export const IMAGING_TABLE_COLUMNS = ["Date", "Lab Name"];
export const FILES_TABLE_COLUMNS = ["Date", "File Name", "File Type"];

export const ENCOUNTER_TABLE_COLUMNS = [
  "Date",
  "Encounter",
  "Type",
  "Location",
  "Weeks",
  "Episode of Care",
];
